/* eslint import/prefer-default-export: 0 */
import * as t from './action_types';

/**
 * @param {String} mode
 */
export const setViewMode = viewMode => ({
  type: t.MESSENGER_SET_VIEW_MODE,
  payload: {
    viewMode,
  },
});

/**
 * @param {String} listMode
 */
export const setConversationListMode = listMode => ({
  type: t.MESSENGER_CONVERSATION_LIST_SET_MODE,
  payload: {
    listMode,
  },
});

/**
 * @param {Boolean} newMessageItemVisible
 */
export const toggleNewMessageItem = newMessageItemVisible => ({
  type: t.MESSENGER_TOGGLE_NEW_MESSAGE_ITEM,
  payload: {
    newMessageItemVisible,
  },
});

/**
 * @param {Boolean} displayContactDetails
 */
export const toggleDisplayContactDetails = displayContactDetails => ({
  type: t.MESSENGER_TOGGLE_DISPLAY_CONTACT_DETAILS,
  payload: {
    displayContactDetails,
  },
});

/**
 * @param {String|Number|null} activeItem
 */
export const selectConversationActiveItem = activeItem => ({
  type: t.MESSENGER_SELECT_CONVERSATION_LIST_ACTIVE_ITEM,
  payload: {
    activeItem,
  },
});

/**
 * @param {Array} selectedRecipientsList
 */
export const setConversationRecipientsList = selectedRecipientsList => ({
  type: t.MESSENGER_SELECT_CONVERSATION_RECIPIENTS_LIST,
  payload: {
    selectedRecipientsList,
  },
});

/**
 * @param {Array} selectedRecipientsWithPhoneNumbers
 */
export const setConversationRecipientsListWithPhoneNumbers = selectedRecipientsWithPhoneNumbers => ({
  type: t.MESSENGER_SELECT_CONVERSATION_RECIPIENTS_WITH_PHONE_NUMBERS,
  payload: {
    selectedRecipientsWithPhoneNumbers,
  },
});

/**
 * @param {Number} recipientID
 */
export const removeSelectedRecipient = recipientID => ({
  type: t.MESSENGER_REMOVE_SELECTED_RECIPIENT,
  payload: {
    recipientID,
  },
});

/**
 * @param {String} recipientPhone
 */
export const addNewRecipient = recipientPhone => ({
  type: t.MESSENGER_ADD_NEW_RECIPIENT,
  payload: {
    recipientPhone,
  },
});

/**
 * @param {Object} recipient
 */
export const addContactsToRecipientList = recipients => ({
  type: t.MESSENGER_ADD_CONTACT_TO_RECIPIENT_LIST,
  payload: {
    recipients,
  },
});

/**
 *
 */
export const clearRecipientList = () => ({
  type: t.MESSENGER_CLEAR_RECIPIENT_LIST,
});

/**
 * @param {String} recipientPhone
 */
export const removeNewRecipient = recipientPhone => ({
  type: t.MESSENGER_REMOVE_NEW_RECIPIENT,
  payload: {
    recipientPhone,
  },
});

/**
 * @param {String} query
 */
export const updateSearchQuery = query => ({
  type: t.MESSENGER_UPDATE_SEARCH_QUERY,
  payload: {
    query,
  },
});

/**
 * @param {Number} conversationId
 */
export const markConversationAsRead = conversationId => ({
  type: t.MESSENGER_MARK_CONVERSATION_AS_READ,
  payload: {
    conversationId,
  },
});

/**
 * @param {Number} conversationId
 */
export const addConversationToSelected = conversationId => ({
  type: t.MESSENGER_ADD_CONVERSATION_TO_SELECTED,
  payload: {
    conversationId,
  },
});

/**
 * @param {Number} conversationId
 */
export const removeConversationFromSelected = conversationId => ({
  type: t.MESSENGER_REMOVE_CONVERSATION_FROM_SELECTED,
  payload: {
    conversationId,
  },
});

/**
 *
 */
export const clearSelectedConversations = () => ({
  type: t.MESSENGER_CLEAR_SELECTED_CONVERSATIONS,
});

/**
 *
 */
export const clearActiveItem = () => ({
  type: t.MESSENGER_CLEAR_ACTIVE_ITEM,
});

/**
 * @param {Boolean} isFetching
 */
export const setConversationsFetchingFlag = isFetching => ({
  type: t.MESSENGER_SET_CONVERSATIONS_FETCHING_FLAG,
  payload: {
    isFetching,
  },
});

/**
 * @param {Boolean} hasNextPage
 */
export const setHasNextPageFlag = hasNextPage => ({
  type: t.MESSENGER_SET_HAS_NEXT_PAGE_FLAG,
  payload: {
    hasNextPage,
  },
});

/**
 * @param {Boolean} isFetching
 */
export const setConversationFetchingFlag = isFetching => ({
  type: t.MESSENGER_SET_CONVERSATION_FETCHING_FLAG,
  payload: {
    isFetching,
  },
});

/**
 * @param {Number} activeConversationId
 * @param {Number} activeContactId
 */
export const setConversationActiveIdentifiers = (activeConversationId, activeContactId) => ({
  type: t.MESSENGER_SET_THREAD_ACTIVE_IDENTIFIERS,
  payload: {
    activeConversationId,
    activeContactId,
  },
});

/**
 * @param {Boolean} isSending
 */
export const setSendingMessageFlag = isSending => ({
  type: t.MESSENGER_SET_SENDING_MESSAGE_FLAG,
  payload: {
    isSending,
  },
});

/**
 * @param {Boolean} isSending
 */
export const setSendingNewMessageFlag = isNewSending => ({
  type: t.MESSENGER_SET_NEW_SENDING_MESSAGE_FLAG,
  payload: {
    isNewSending,
  },
});

/**
 * @param {Object} contacts
 */
export const setContactsToUpdatePhoneNumbers = contacts => ({
  type: t.MESSENGER_SET_CONTACTS_TO_UPDATE_PHONE_NUMBERS,
  payload: {
    contacts,
  },
});

/**
 * @param {Number} contactId
 */
export const removeContactFromUpdatePhoneNumbers = contactId => ({
  type: t.MESSENGER_REMOVE_CONTACT_FROM_UPDATE_PHONE_NUMBERS,
  payload: {
    contactId,
  },
});

/**
 *
 */
export const resetContactsToUpdatePhoneNumbers = () => ({
  type: t.MESSENGER_RESET_CONTACTS_TO_UPDATE_PHONE_NUMBERS,
});

/**
 *
 */
export const clearContactsToUpdatePhoneNumbers = () => ({
  type: t.MESSENGER_CLEAR_CONTACTS_FOR_UPDATE_PHONE_NUMBERS,
});
